import { Box } from '@breathelife/mui';
import { ReactElement, useContext } from 'react';

import { ThirdPartyIntegrationCard } from './ThirdPartyIntegrationCard';
import { ThirdPartyIntegrationsContext } from './ThirdPartyIntegrationsContextProvider';

export function ThirdPartyIntegrationsBoard(): ReactElement {
  const { thirdPartyIntegrations } = useContext(ThirdPartyIntegrationsContext);
  return (
    <Box display='grid' gridAutoFlow={'row'} gap='24px' gridTemplateColumns='repeat(auto-fill, minmax(250px, 1fr))'>
      {thirdPartyIntegrations.map((integration) => (
        <Box key={integration.id} flexGrow='grow'>
          <ThirdPartyIntegrationCard data={integration} />
        </Box>
      ))}
    </Box>
  );
}
